import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Formik } from 'formik'
import { Trans } from 'react-i18next'

import Api from 'services/Api'
import { Button, Textarea, Form } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { AvailabilitiesDispo } from 'components/Requests'
import { Format } from 'services/Dates'
import { closeModal } from 'store/actions/modals'
import { refreshCounter } from 'store/actions/refresh'
import { getUserName } from 'services/Utilities'
import { Card } from 'ui'
import { t } from 'translations'

function AvailabilityRequestChangesModal({ availability }) {
  const dispatch = useDispatch()
  const { defaultTimeZone: timeZone } = useSelector(state => state.settings)

  const onSubmit = async ({ comment }) => {
    const { success } = await Api.put(`/requests/availability`, {
      changeApprovalStatus: true,
      newStatus: 'CHANGES_REQUESTED',
      availabilityToApprove: { ...availability, comment }
    })
    dispatch(refreshCounter('availabilities'))
    if (success) dispatch(closeModal())
  }

  return (
    <BaseModal hideButtons title="manager.availabilities.REQUEST_CHANGES_MODAL" titleVar={{ fullName: getUserName(availability.userId) }}>
      <Formik enableReinitialize={true} initialValues={{ comment: availability.comment }} onSubmit={onSubmit}>
        {({ isSubmitting }) => {
          return (
            <Form className="mt-2">
              <Card className="bg-light mt-2">
                <Card.Body>
                  {/* Availability info */}
                  <div className="d-flex flex-column">
                    <div>
                      <Trans t={t} i18nKey="manager.availabilities.DATE_VALID">
                        <b>{{ date: Format(availability.dateValid, { outFormat: 'date', isUTC: true, timeZone }) }}</b>
                      </Trans>
                    </div>
                    {availability.notes ? (
                      <div>
                        <b>{t('manager.availabilities.NOTES')}</b> {availability.notes}
                      </div>
                    ) : null}
                    <AvailabilitiesDispo days={availability.days} />
                  </div>
                </Card.Body>
              </Card>
              <Textarea module="manager.availabilities.REQUEST_CHANGES_MODAL" name="comment" />
              <div className="mt-2">
                <Button className="btn btn-primary mr-2" type="submit" isSubmitting={isSubmitting} text="SUBMIT" />
                <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
                  {t(`actions.CLOSE`)}
                </Button>
              </div>
            </Form>
          )
        }}
      </Formik>
    </BaseModal>
  )
}

export default AvailabilityRequestChangesModal
